import { config } from '@/lib';

const PkItem = (props) => {};

const RoomItem = (props) => {
  const { star, index, saId, clickfrom } = props;
  var starId = star.star_id;

  //   var star = item.detail[j];
  // if (j == 0) { star1 = star } else { star2 = star }

  return (
    <a
      className={`star-item star-${starId}`}
      data-id={starId}
      data-index={index}
      href={`/${starId}?clickfrom=${clickfrom}`}
      target="_blank"
      data-sawebclick={saId ? 'id=' + saId + '&desc=' + starId : ''}
    >
      <div className="star-avatar">
        <img
          className="lazyimg"
          src={config.defaultImg}
          data-original={star.app_pic_url || star.pic_url}
          alt={star.nick_name}
          title={star.nick_name}
        />
      </div>
      <div className="icon-index icon-index-pking"></div>
      <i className="icon-index icon-index-live-circle"></i>
    </a>
  );
};

const PkList = (props) => {
  const { data, clickfrom } = props;
  var list = data.list || [];
  var isAuto = data.isAuto || false;
  var length = isAuto ? Math.min(list.length, 6) : list.length;
  var saId = data.saId || '';

  return (
    <>
      {list.map((item) => {
        const [star1, star2] = item.detail;

        let sumTotal =
          (star1.timing_pk_total || 0) + (star2.timing_pk_total || 0);
        var star1Len =
          sumTotal === 0 ? 225 : (star1.timing_pk_total / sumTotal) * 450;
        var star2Len =
          sumTotal === 0 ? 235 : (star2.timing_pk_total / sumTotal) * 450 + 10;
        star1Len = Math.max(10, star1Len);
        star2Len = Math.min(450, star2Len);

        return (
          <div className="pk-item" key={star1.star_id}>
            <div className="pk-stars clearfix">
              <RoomItem
                star={star1}
                clickfrom={clickfrom}
                saId={saId}
                index="0"
              ></RoomItem>
              <RoomItem
                star={star2}
                clickfrom={clickfrom}
                saId={saId}
                index="1"
              ></RoomItem>
            </div>
            <i className="icon-index icon-index-vs"></i>
            <div className="pk-progress-bar-wrap">
              <i
                className="pk-progress-bar progress-left"
                style={{ width: `${star1Len}px` }}
              ></i>
              <i
                className="pk-progress-bar progress-right"
                style={{ width: `${star2Len}px` }}
              ></i>
              <div className="pk-total pk-total-left">
                {star1.timing_pk_total}
              </div>
              <div className="pk-total pk-total-right">
                {star2.timing_pk_total}
              </div>
            </div>
            <div className="star-nicknames clearfix">
              <span className="text-overflow">{star1.nick_name}</span>
              <span className="text-overflow">{star2.nick_name}</span>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default PkList;
